// src/components/common/AccordionPanel.tsx

import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface AccordionPanelProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
}

const AccordionPanel: React.FC<AccordionPanelProps> = ({
  title,
  defaultOpen = false,
  children,
  className = '',
  titleClassName = '',
  contentClassName = '',
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`rounded-xl overflow-hidden border border-gray-200 bg-white ${className}`}>
      <button
        className={`w-full flex justify-between items-center px-4 py-4 hover:bg-gray-50 transition-colors ${titleClassName}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="font-medium text-gray-800">{title}</span>
        {isOpen ? <ChevronUp size={20} className="text-gray-500" /> : <ChevronDown size={20} className="text-gray-500" />}
      </button>
      
      {isOpen && (
        <div className={`px-4 py-3 border-t border-gray-100 ${contentClassName}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default AccordionPanel;